import React from "react";
import { Link, useOutletContext } from "react-router-dom";
import { ArrowRight, CalendarDays, Radio, IdCard, ShoppingBag, GraduationCap, Sparkles } from "lucide-react";

export default function Home() {
  const { content } = useOutletContext() || {};
  const c = content || {};

  return (
    <div>
      <section className="relative overflow-hidden grain">
        <div className="absolute inset-0 hero-grid opacity-70"></div>
        <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 pt-16 pb-20 lg:pt-24 lg:pb-32">
          <div className="grid lg:grid-cols-12 gap-10 items-end">
            <div className="lg:col-span-7">
              <div className="tag-pill mb-6" data-testid="hero-tag">
                <span className="w-1.5 h-1.5 bg-white rounded-full"></span>
                {c.hero_tag || "Circolo culturale · Bologna"}
              </div>
              <h1 className="font-display text-6xl sm:text-7xl lg:text-8xl leading-[0.9] uppercase text-white" data-testid="hero-heading">
                {c.hero_title_1 || "Il flusso"}<br/>
                <span className="text-white">{c.hero_title_2 || "della cultura"}</span><br/>
                {c.hero_title_3 || "bolognese"}
              </h1>
              <p className="mt-6 text-lg text-white/80 max-w-xl">
                {c.hero_subtitle || "Eventi, podcast dal vivo, corsi e tesseramento per le associazioni DAMACO APS e ROCCA APS."}
              </p>
              <div className="mt-8 flex flex-col sm:flex-row gap-3">
                <Link to="/tesseramento" className="brutal-btn brutal-btn-primary" data-testid="cta-tesserati">
                  Tesserati ora — 6€ <ArrowRight size={16}/>
                </Link>
                <Link to="/eventi" className="brutal-btn brutal-btn-outline" data-testid="cta-eventi">
                  Scopri gli eventi
                </Link>
              </div>
            </div>
            <div className="lg:col-span-5">
              <div className="relative">
                {c.hero_image_url && /\.(mp4|webm|mov|m4v)(\?|$)/i.test(c.hero_image_url) ? (
                  <video src={c.hero_image_url} autoPlay muted loop playsInline
                    className="w-full aspect-[4/5] object-cover border border-white"
                    data-testid="hero-video"/>
                ) : c.hero_image_url ? (
                  <img src={c.hero_image_url} alt="Flow.Bologna"
                    className="w-full aspect-[4/5] object-cover border border-white"
                    data-testid="hero-image"/>
                ) : (
                  <div className="w-full aspect-[4/5] border border-white flex items-center justify-center bg-black">
                    <div className="text-center text-white/40">
                      <div className="font-display text-6xl">FLOW</div>
                      <div className="mt-4 text-xs font-mono uppercase tracking-widest">Immagine o video da caricare</div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="border-y border-white/40 bg-black">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-14 grid md:grid-cols-3 gap-8">
          <div>
            <div className="tag-pill">{c.bio_tag || "Chi siamo"}</div>
            <h2 className="mt-4 font-display text-4xl uppercase text-white">{c.bio_title || "Un circolo, due APS"}</h2>
          </div>
          <div className="md:col-span-2 text-white/80 text-base leading-relaxed whitespace-pre-line">
            {c.bio_text || ""}
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-20">
        <div className="mb-10 flex items-end justify-between">
          <h2 className="font-display text-5xl uppercase text-white">Esplora</h2>
          <div className="tag-pill hidden sm:inline-flex"><Sparkles size={12}/> Aree del circolo</div>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {[
            { to: "/eventi", icon: CalendarDays, title: "Eventi", desc: "Live music, mostre, incontri. Biglietti e prenotazioni.", tid: "card-eventi" },
            { to: "/podcast", icon: Radio, title: "Podcast", desc: "Diretta live e archivio. Prenota il tuo slot.", tid: "card-podcast" },
            { to: "/tesseramento", icon: IdCard, title: "Tesseramento", desc: "Iscriviti a DAMACO APS o ROCCA APS. Solo 6€.", tid: "card-tesseramento" },
            { to: "/corsi", icon: GraduationCap, title: "Corsi", desc: "Formazione e workshop del circolo.", tid: "card-corsi" },
            { to: "/shop", icon: ShoppingBag, title: "Merchandising", desc: "Cappelli, magliette, accessori e altro.", tid: "card-shop" },
          ].map(({to, icon: Icon, title, desc, tid}) => (
            <Link key={to} to={to} data-testid={tid} className="card p-6 flex flex-col justify-between min-h-[220px] group">
              <div>
                <div className="w-12 h-12 flex items-center justify-center border border-white text-white">
                  <Icon size={22}/>
                </div>
                <h3 className="mt-6 font-display text-3xl uppercase text-white">{title}</h3>
                <p className="mt-2 text-white/70 text-sm">{desc}</p>
              </div>
              <div className="mt-6 flex items-center gap-2 text-xs font-mono uppercase tracking-widest text-white/70 group-hover:text-white">
                Entra <ArrowRight size={14}/>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
